import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
export const wishListEndpoints = {
    get: 'api/wishlist/basic',
    add: 'api/wishlist/product/add',
    remove: 'api/wishlist/product/remove',
    lister: 'api/wishlist/lister',
    login: 'api/wishlist/login',
    logout: 'api/wishlist/logout',
};
class WishListApi {
    getWishlistProducts(apiPrefix, authenticationConfig, showOutOfStock) {
        const axiosConfig = {
            method: 'GET',
            url: `${apiPrefix}${wishListEndpoints.get}`,
            withCredentials: true,
            params: showOutOfStock ? Object.assign(Object.assign({}, authenticationConfig), { showOutOfStock }) : authenticationConfig,
        };
        return axiosClient.request(axiosConfig).then(response => response.data.products);
    }
    addProductToWishList(product, apiPrefix, authenticationConfig) {
        const axiosConfig = {
            method: 'POST',
            url: `${apiPrefix}${wishListEndpoints.add}`,
            withCredentials: true,
            data: product,
            params: authenticationConfig,
        };
        return axiosClient.request(axiosConfig);
    }
    removeProductFromWishList(product, apiPrefix, authenticationConfig) {
        const axiosConfig = {
            method: 'POST',
            url: `${apiPrefix}${wishListEndpoints.remove}`,
            withCredentials: true,
            data: product,
            params: authenticationConfig,
        };
        return axiosClient.request(axiosConfig);
    }
    getWishlistListerProducts(apiPrefix, defaultRequestParams, size, page, showOutOfStock) {
        return __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${apiPrefix}${wishListEndpoints.lister}`,
                withCredentials: true,
                params: Object.assign(Object.assign({}, defaultRequestParams), { size,
                    page,
                    showOutOfStock }),
            };
            const result = yield axiosClient.request(axiosConfig);
            if (result.data) {
                return {
                    totalPages: result.data.totalPages,
                    itemCount: result.data.itemCount,
                    items: result.data.items.map((product) => (Object.assign(Object.assign({}, product), { colours: product.colours.map((color) => (Object.assign(Object.assign({}, color), { inWishList: true }))) }))),
                };
            }
            return null;
        });
    }
    login(apiPrefix, authenticationConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${apiPrefix}${wishListEndpoints.login}`,
                withCredentials: true,
                params: authenticationConfig,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
    logout(apiPrefix, authenticationConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'POST',
                url: `${apiPrefix}${wishListEndpoints.logout}`,
                withCredentials: true,
                params: authenticationConfig,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new WishListApi();
